import { NotificationOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { history, SelectLang as UmiSelectLang, useLocation } from '@umijs/max';
import { Badge, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';

import { getSelfProgressReminderUnreadCount } from '@/services/development/learn-progress';
import { getInternalNoticeUnreadCount } from '@/services/system-settings/internal-notices/api';

export type SiderTheme = 'light' | 'dark';

export const SelectLang = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
      }}
      onClick={() => {
        // window.open('https://pro.ant.design/docs/getting-started');
      }}
    >
      <QuestionCircleOutlined />
    </div>
  );
};

export const InternalNoticeAction = () => {
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  const [reminderCount, setReminderCount] = useState(0);

  useEffect(() => {
    let active = true;

    const loadUnreadCount = async () => {
      try {
        const [noticeResult, reminderResult] = await Promise.all([
          getInternalNoticeUnreadCount(),
          getSelfProgressReminderUnreadCount({ skipErrorHandler: true }),
        ]);

        if (!active) {
          return;
        }

        setUnreadCount(Number(noticeResult?.data ?? 0));
        setReminderCount(Number(reminderResult?.data ?? 0));
      } catch {
        if (active) {
          setUnreadCount(0);
          setReminderCount(0);
        }
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        void loadUnreadCount();
      }
    };

    void loadUnreadCount();
    window.addEventListener('focus', handleVisibilityChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      active = false;
      window.removeEventListener('focus', handleVisibilityChange);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [location.pathname]);

  const totalUnread = unreadCount + reminderCount;
  const tooltipTitle =
    totalUnread > 0
      ? `未読のお知らせ ${unreadCount} 件 / 学習リマインド ${reminderCount} 件`
      : '社内公示・お知らせ';

  return (
    <Tooltip title={tooltipTitle}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 32,
          width: 32,
          cursor: 'pointer',
        }}
        onClick={() => {
          if (location.pathname !== '/internal-notices') {
            history.push('/internal-notices');
          }
        }}
      >
        <Badge dot={totalUnread > 0} offset={[-2, 4]}>
          <NotificationOutlined style={{ fontSize: 16 }} />
        </Badge>
      </div>
    </Tooltip>
  );
};
